export var DOI_HELPER_TEXT = 'If your source was found online, the online publication information will be replaced by the DOI.';
export var DEFAULT_SELECTED_DISPLAY_URL_INDEX = 1;
export var DEFAULT_SELECTED_SEARCH_TYPE_INDEX = 2;
export var FORM_TAB_GROUP_ARIA_LABEL = 'Format';
export var DISPLAY_URL_LABEL_TEXT = 'Display URL?';
// Federal sections fields labels
export var YEAR_PUBLISHED = 'Year published';
export var ADVANCED_INFO = 'Advanced info';
export var PUBICATION_INFO = 'Publication info';
export var PAGES = 'Pages';
export var WEBSITE_TITLE = 'Website title';
export var URL = 'URL';
export var DATE_ACCESSED = 'Date accessed';
export var CONGRESS = 'Congress';
export var START = 'Start page';
export var PUBLISHER = 'Publisher';

// Mailing List and Newsgroup Section fields
export var MAILING_TITLE = 'Site / Mailing list title';
export var NEWSGROUP_TITLE = 'Site / Newsgroup title';
export var MAILING_PUBLISHER = 'Publisher / sponsor';
export var ELEC_PUB_DATE = 'Electronically published';

// InPrint section labels
export var SOURCE_TITLE = 'Source title';
export var CITY = 'City';
export var STATE = 'State';
export var YEAR = 'Year';
export var SOURCE_WELL_KNOWN = 'Is this source well known?';
export var WELL_KNOWN = 'Well Known?';
export var END = 'End page';
export var VOL = 'Vol.';
export var TOTAL_VOLUMES = 'Total vols.';
export var EDITION = 'Edition';
export var PAGES_ARE_NONSECUTIVE = 'Pages are nonconsecutive';

// Online/Website section labels
export var PUBLISHER_SPONSOR = 'Publisher/sponsor';
export var ELECTRONICALLY_PUBLSIHED = 'Electronically published';
export var DISSERATION_ABSTRACT_ONLINE_TITLE = 'Site / Dissertationabstract title';

// Online database fields
export var LIBRARY = 'Library';
export var DATABASE = 'Database';
export var SERVICE = 'Service';
export var SEARCH_TYPE = 'Search type';
export var SERIES = 'Series';
export var PAGES_ARE_NONCONSECUTIVE = 'Pages are nonconsecutive';
export var COLLECTION_SOURCE = 'Collection source';
export var COLLECTION_TITLE = 'Collection title	';

// helper texts and other labels
export var SOURCE = 'Source';
export var VOLUME = 'Volume';

// Map form labels
export var PAGES_NON_CONSECUTIVE = 'Pages are nonconsecutive';

// Raw Data section labels
export var LOCATION = 'Location';
export var COMPANY_ORGANISATION = 'Company / org.';

// Other section labels
export var DATE_PUBLISHED = 'Date published';
export var ONLY_IF_CITY_NOT_IN_NEWSPAPER_NAME = 'Only include if city is not in newspaper name';

// Journal fields
export var JOURNAL_TITLE = 'Journal title';
export var ISSUE = 'Issue';
export var RESTARTS_PAGE_NUMBERING = 'Every issue restarts page numbering';

// Magazine fields
export var MAGAZINE_TITLE = 'Magazine title';

// Newapaper fields
export var NEWSPAPER_TITLE = 'Newspaper title';
export var SECTION = 'Section';

// Live section labels
export var DATE_VIEWED = 'Date viewed';

// Microform fields
export var MICROFORM_TITLE = 'Microform title';
export var IDENTIFIER = 'Identifier';
export var IDENTIFIER_HELPERTEXT = 'Ex: fiche 4, grids 5-6';